import SearchCriteriaFactory from "./SearchCriteriaFactory";
import { atom } from "recoil";

export const searchCriteriaState = atom({
    key: "searchCriteriaState",
    default: SearchCriteriaFactory.getAllResultsCriteria()
});